import type { SbirSearchFilter } from '@/types/sbir/Filter'

export const DEFAULT_SBIR_FILTER: SbirSearchFilter = {
  is_active: null,
  active_after: null,
  active_before: null,
  published_after: null,
  published_before: null,
  numbers: [],
  programs: [],
  phases: [],
  agencies: [],
  branches: [],
  current_statuses: [],
  topic_branches: [],
  topic_numbers: [],
}

export const PHASES = ['Phase I', 'Phase II', 'BOTH']

export const PHASE_MAP: Record<string, string> = {
  'Phase I': 'Phase I Only',
  'Phase II': 'Phase II Only',
  BOTH: 'Both Phases',
}

// export const PROGRAMS = ['SBIR', 'STTR', 'BOTH']
export const PROGRAMS = ['SBIR', 'STTR']
